import comp from "./CommunityBasicDetails";
export default comp;
